module.exports = __webpack_public_path__ + "static/media/Salestip-close.863c0e59.svg";